import companyCardsSlice from './companyCardsSlice'
export default companyCardsSlice.reducer
